'use client';
import * as React from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const propTypes = {};
const propKeysToRemove = Object.keys(propTypes);
/**
 * List of navigation items to render inside of the anchor bar
 *
 * @subcomponent AnchorBar
 */ const AnchorBarList = renderWithRef('SubNavList', propTypes, (props, ref)=>{
    const classNames = new Set([
        'swan-anchor-bar-list'
    ]);
    const { children } = props;
    return /*#__PURE__*/ React.createElement(RenderComp, {
        root: "ul",
        forwardedRef: ref,
        propKeysToRemove: propKeysToRemove,
        classNames: classNames,
        props: props
    }, children);
});

export { AnchorBarList };
